import type { MarketingCampaignFormModel } from "../../../../../type";
import type { ServerModel } from "../../type";

export const serverModelToInputModelConverter = (
	serverModel: ServerModel,
): MarketingCampaignFormModel["InputModel"] => {
	const { voucherForCampaignNewItem } = serverModel;

	const inputModel: MarketingCampaignFormModel["InputModel"] = {
		hotelID: voucherForCampaignNewItem.hotelID,
		voucherID: voucherForCampaignNewItem.voucherID,

		inSale: voucherForCampaignNewItem.inSale,

		name: voucherForCampaignNewItem.name,
		description: voucherForCampaignNewItem.description,

		mainKeyVisual: voucherForCampaignNewItem.mainKeyVisual,

		voucherPrice: voucherForCampaignNewItem.voucherPrice,
		resourceAvailablePrice: voucherForCampaignNewItem.resourceAvailablePrice,

		mailTemplate: voucherForCampaignNewItem.mailTemplate,
		voucherExplanationForHost: voucherForCampaignNewItem.voucherExplanationForHost,
		voucherGiftList: voucherForCampaignNewItem.voucherGiftList.map((item) => {
			return {
				guestEmail: item.guestEmail ?? "",
				guestName: item.guestName,
				guestTel: item.guestTel,
			};
		}),

		cinStart: voucherForCampaignNewItem.cinStart,
		cinEnd: voucherForCampaignNewItem.cinEnd,
	} satisfies MarketingCampaignFormModel["InputModel"];

	return inputModel;
};
